import React from 'react'
import styles from './styles.module.css'
import Img from '../../../Img' // task #67: canonical image component
import SimpleBlockContent from '../../../SimpleBlockContent'
import { PALETTE } from '../../../../styles/constants'

const cx = (...c) => c.filter(Boolean).join(' ')

function ProductImageAndSpecs({ titleWithHighlight, image, specs, horizontal }) {
  return (
    <div className={styles.wrapper}>
      <div className={cx(styles.contentWrapper, !!image && styles.contentWrapperHasImage)}>
        <div className={cx(styles.title, !!titleWithHighlight.highlight && styles.titleHasHighlight)}>
          <SimpleBlockContent
            blocks={titleWithHighlight.text}
            highlight={titleWithHighlight.highlight}
            highlightSx={`color: ${PALETTE.white};`}
            noSpace/>
        </div>
        {
          image && (
            <div className={styles.imageWrapper}>
              {/* task #67: descriptor via <Img> */}
              <Img
                image={image}
                alt={titleWithHighlight.text}
                layout="fill"
                objectFit="contain"
              />
            </div>
          )
        }
        { renderSpecsList(specs, horizontal) }
      </div>
    </div>
  )
}

const renderSpecsList = (specs, horizontal) => {
  if (!specs) return null

  return (
    <div className={cx(styles.specsWrapper, horizontal && styles.specsWrapperHorizontal)}>
      { specs.map(spec => renderSingleSpec(spec.title, spec.subtitle, spec.icon))}
    </div>
  )
}

const renderSingleSpec = (title, subtitle, icon) => {
  return (
    <div className={styles.spec}>
      {/* eslint-disable-next-line local-rules/img-requires-dimensions -- faithful port of the former (empty) styled.img Icon: no reserved box existed pre-migration; sizing is intrinsic/CSS-driven, adding fabricated dimensions would alter layout (#89) */}
      {icon && <img src={icon?.src}/>}{/* task #67: styled img src from descriptor */}
      <div className={styles.specTitle}>
        <SimpleBlockContent blocks={title} noSpace/>
      </div>
      <div className={styles.specSubtitle}>
        <SimpleBlockContent blocks={subtitle} noSpace/>
      </div>
    </div>
  )
}

export default ProductImageAndSpecs
